import React from 'react';

import {SelectTypeFilter} from 'app/components/general/SelectTypeFilter';
import {SORT_BY_TYPES} from 'app/utils/constants';
import {gt} from 'app/utils/i18n';

import type {SortOptionType} from 'app/utils/constants';

export const getSortOptions = (options: Array<SortOptionType>) =>
  [
    {
      value: SORT_BY_TYPES.MODIFICATION_DATE,
      text: gt('Recently Edited'),
    },
    {
      value: SORT_BY_TYPES.APPROVED_DATE_DESC,
      text: gt('Recently Approved'),
    },
    {
      value: SORT_BY_TYPES.REVIEWED_DATE_DESC,
      text: gt('Recently Reviewed'),
    },
    {
      value: SORT_BY_TYPES.REVIEWED_DATE_ASC,
      text: gt('Oldest Reviewed'),
    },
    {
      value: SORT_BY_TYPES.CREATION_DATE,
      text: gt('Recently Created'),
    },
    {
      value: SORT_BY_TYPES.DATE_JOINED_DESC,
      text: gt('Recently Joined'),
    },
    {
      value: SORT_BY_TYPES.ALPHABETHICALLY,
      text: gt('Alphabetical'),
    },
    {
      value: SORT_BY_TYPES.RANK,
      text: gt('Relevance'),
    },
    {
      value: SORT_BY_TYPES.REVIEWED_DATE_NEXT_ASC,
      text: gt('Next Review Date'),
    },
    {
      value: SORT_BY_TYPES.LAST_SIGNED_OFF_DATE_DESC,
      text: gt('Recently Signed Off'),
    },
    {
      value: SORT_BY_TYPES.LAST_REQUEST_SENT_DATE_DESC,
      text: gt('Recently Requested Sign Off'),
    },
    {
      value: SORT_BY_TYPES.DUE,
      text: gt('Due Date'),
    },
    {
      value: SORT_BY_TYPES.DUE_DESC,
      text: gt('Due Date Descending'),
    },
    {
      value: SORT_BY_TYPES.ALPHABETICALLY_CURRENT_NAME,
      text: gt('Alphabetical'),
    },
    {
      value: SORT_BY_TYPES.DELETION_DATE,
      text: gt('Recently Deleted'),
    },
  ].filter((opt) => options.indexOf(opt.value) > -1);

type Props = {
  value: SortOptionType;
  options: Array<SortOptionType>;
  onChange: (value: SortOptionType) => void;
  backendDefaultSort?: SortOptionType;
};

export const DashboardFilterbarSort = ({
  value,
  options,
  onChange,
  backendDefaultSort = SORT_BY_TYPES.MODIFICATION_DATE,
}: Props) => (
  <SelectTypeFilter
    className="form-control"
    filterValue={value != null ? value : backendDefaultSort}
    onChange={(value) => onChange(value !== backendDefaultSort ? value : '')}
    options={getSortOptions(options)}
  />
);
